export default __webpack_public_path__ + "d5ffd047b7c02733f5850141ae1fa991.png";